import { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

// 권위: docs/ARCH_DASHBOARD.md §6.1.3 라우터 구조 / §3.1 AuthGuard 책임
// - bootstrapping 중: 스피너 표시 (refresh 쿠키 복구 시도 중)
// - 미인증: /login?redirect_to=<원래 URL> 으로 리다이렉트
// - 인증: children 렌더

export function AuthGuard({ children }: PropsWithChildren): JSX.Element {
  const accessToken = useAuthStore((s) => s.accessToken);
  const bootstrapping = useAuthStore((s) => s.bootstrapping);
  const location = useLocation();

  if (bootstrapping) {
    return (
      <div className="auth-bootstrap">
        <div role="status" aria-live="polite">
          세션 복구 중...
        </div>
      </div>
    );
  }

  if (!accessToken) {
    const redirectTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect_to=${redirectTo}`} replace />;
  }

  return <>{children}</>;
}
